"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzChartPie__Wrapper",
  componentId: "sc-dzsip8-0"
})(["\n  position: relative;\n  width: ", "px;\n  height: ", "px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n  background-color: #ffffff;\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"], function (props) {
  return props.size;
}, function (props) {
  return props.size;
});

var Pie = _styledComponents.default.div.withConfig({
  displayName: "OzChartPie__Pie",
  componentId: "sc-dzsip8-1"
})(["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: ", "px;\n  height: ", "px;\n  border-radius: ", "px;\n\n  /*background-color: ", ";*/\n  background: conic-gradient(", ") 0 0;\n"], function (props) {
  return props.size;
}, function (props) {
  return props.size;
}, function (props) {
  return props.size / 2;
}, function (props) {
  return props.color;
}, function (props) {
  return props.background;
});

var Center = _styledComponents.default.div.withConfig({
  displayName: "OzChartPie__Center",
  componentId: "sc-dzsip8-2"
})(["\n  position: absolute;\n  top: ", "px;\n  left: ", "px;\n  width: calc(", "px - ", "px);\n  height: calc(", "px - ", "px);\n  border-radius: ", "px;\n\n  background-color: #ffffff;\n\n  overflow: hidden;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n\n"], function (props) {
  return props.thickness;
}, function (props) {
  return props.thickness;
}, function (props) {
  return props.size;
}, function (props) {
  return props.thickness * 2;
}, function (props) {
  return props.size;
}, function (props) {
  return props.thickness * 2;
}, function (props) {
  return props.size / 2;
});
/*const Slice = styled.div`
  position: absolute;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  border-radius: ${props => props.size/2}px;
  clip: rect(0px, ${props => props.size}px, ${props => props.size}px, ${props => props.size/2}px);
  transform: rotate(${props => props.offset}deg);

  &:after{
    content: "";
    display: block;

    position: absolute;
    width: ${props => props.size}px;
    height: ${props => props.size}px;
    border-radius: ${props => props.size/2}px;
    clip: rect(0px, ${props => props.size/2}px, ${props => props.size}px, 0px);

    background-color: ${props => props.color};
    transform:rotate(${props => props.value}deg);
  }
`;*/


var OzChartPie = function OzChartPie(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 150 : _ref$size,
      _ref$thickness = _ref.thickness,
      thickness = _ref$thickness === void 0 ? 8 : _ref$thickness,
      _ref$values = _ref.values,
      values = _ref$values === void 0 ? [] : _ref$values,
      _ref$voidColor = _ref.voidColor,
      voidColor = _ref$voidColor === void 0 ? "#EBEBEB" : _ref$voidColor,
      _ref$fnCallback = _ref.fnCallback,
      fnCallback = _ref$fnCallback === void 0 ? function () {} : _ref$fnCallback,
      _ref$fnFormatValue = _ref.fnFormatValue,
      fnFormatValue = _ref$fnFormatValue === void 0 ? function (ret) {
    return ret;
  } : _ref$fnFormatValue,
      children = _ref.children;
  var offset = 0;
  values.forEach(function (item) {
    item.offset = offset;
    offset += item.value;
  });
  var prevValue = 0;
  return __jsx(Wrapper, {
    size: size
  }, __jsx(Pie, {
    size: size,
    voidColor: voidColor,
    background: values.length > 0 ? values.concat([{
      "color": voidColor,
      "value": 100 - offset
    }]).map(function (item, i) {
      var string = item.color + " " + prevValue + "deg, ";
      prevValue = prevValue + item.value * 360 / 100;
      string = string + item.color + " " + prevValue + "deg";
      return string;
    }).join(", ") : null
  }, __jsx(Center, {
    size: size,
    thickness: thickness
  }, children)));
};

var _default = OzChartPie;
exports.default = _default;